import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const getAdminHideColumnsAPI = createApi("GetAdminHideColumns","GET");

const GetAdminHideColumns = createSlice({
  name: 'GetAdminHideColumns',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAdminHideColumnsAPI.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAdminHideColumnsAPI.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getAdminHideColumnsAPI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetAdminHideColumns.reducer;